import { render, staticRenderFns } from "./QuotaModal.vue?vue&type=template&id=5aff321a&scoped=true&"
import script from "./QuotaModal.vue?vue&type=script&lang=js&"
export * from "./QuotaModal.vue?vue&type=script&lang=js&"
import style0 from "./QuotaModal.vue?vue&type=style&index=0&id=5aff321a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aff321a",
  null
  
)

export default component.exports